// extracted by mini-css-extract-plugin
module.exports = {"date":"styles_date__3cdnr","description":"styles_description__3z2Gj"};